import {Directive, Input} from '@angular/core';

@Directive({
  selector: '[error-src]',
  host: {
    '(error)': 'onError($event.target)'
  }
})
export class ErrorSrcDirective {

  constructor() { }
  private image = '../../../assets/user-header.png';

  @Input('err-src')
  set backImg(img:string) {
    if (img) this.image = img;
  }

  onError(e) {
    e.src = this.image;
  }

}
